import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center">
          <p className="text-gray-400 text-sm mb-2">
            Copyright © 2025 Motor Approval. All rights reserved. Motor Approval® and the Motor Approval Logo design are registered trademarks of Motor Approval Ltd. Other trademarks are the property of their respective owners.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
